<!-- @panel -->
<aside
  *ngIf="open"
  class="sidebar-panel w-full h-full overflow-y-auto p-2 m-0 rounded-none shadow-none"
  [class.sidebar-panel--collapsed]="collapsed"
  role="navigation"
  aria-label="Sidebar"
  (click)="stop($event)">
  <!-- Sidebar header -->
  <div
    class="h-14 w-full flex items-center justify-center p-0"
    [class.py-2]="collapsed">
    @if (collapsed) {
    <img
      class="w-8 h-8 object-contain"
      src="assets/SVG/Seulah_App_logo.png"
      alt="Seulah" />
    } @else {
    <img
      class="flex justify-center w-25 h-auto px-2 py-4"
      src="assets/images/seulah_white_logo.png"
      alt="Seulah" />
    }
  </div>

  <!-- Sidebar body -->
  <div
    class="overflow-y-auto mt-4 space-y-4"
    [class.h-[calc(100vh-100px)]]="!collapsed"
    [class.h-[calc(100vh-80px)]]="collapsed">
    <!-- Personal Section -->
    <section>
      <p
        class="text-white text-sm font-medium mb-2"
        [ngClass]="collapsed
          ? 'px-0 text-center text-[10px] underline-offset-2 truncate'
          : 'underline pl-3'">
        {{ collapsed ? ('sidebar.Personal' | translate | slice:0:3) + '..' : ('sidebar.Personal' | translate) }}
      </p>
      <ul class="space-y-1">
        <li
          (click)="close()"
          routerLink="/dashboard"
          routerLinkActive="active-link"
          class="sidebar-item group flex items-center cursor-pointer hover:bg-white/10"
          [ngClass]="collapsed ? 'justify-center px-0 py-3' : 'gap-3 pl-3 py-3'"
          [title]="'sidebar.Home' | translate">
          <img src="assets/SVG/sidebar/home.svg" class="w-5 h-5 opacity-80 shrink-0" alt="" />
          @if (!collapsed) {
          <span class="text-white text-sm">{{ "sidebar.Home" | translate }}</span>
          }
        </li>

        <li
          (click)="close()"
          routerLink="/finance-history"
          routerLinkActive="active-link"
          class="sidebar-item group flex items-center cursor-pointer hover:bg-white/10"
          [ngClass]="collapsed ? 'justify-center px-0 py-3' : 'gap-3 pl-3 py-3'"
          [title]="'sidebar.Finance_History' | translate">
          <img src="assets/SVG/sidebar/finance_history.svg" class="w-5 h-5 opacity-80 shrink-0" alt="" />
          @if (!collapsed) {
          <span class="text-white text-sm">{{ "sidebar.Finance_History" | translate }}</span>
          }
        </li>

        <li
          (click)="close()"
          routerLink="/eligibility-checker"
          routerLinkActive="active-link"
          class="sidebar-item group flex items-center cursor-pointer hover:bg-white/10"
          [ngClass]="collapsed ? 'justify-center px-0 py-3' : 'gap-3 pl-3 py-3'"
          [title]="'sidebar.Eligibility_Checker' | translate">
          <img src="assets/SVG/sidebar/eligibility_checker.svg" class="w-5 h-5 opacity-80 shrink-0" alt="" />
          @if (!collapsed) {
          <span class="text-white text-sm">{{ "sidebar.Eligibility_Checker" | translate }}</span>
          }
        </li>

        <li
          (click)="close()"
          routerLink="/loan-history"
          routerLinkActive="active-link"
          class="sidebar-item group flex items-center cursor-pointer hover:bg-white/10"
          [ngClass]="collapsed ? 'justify-center px-0 py-3' : 'gap-3 pl-3 py-3'"
          [title]="'sidebar.LOAN_HISTORY' | translate">
          <img src="assets/SVG/sidebar/loan_history.svg" class="w-5 h-5 opacity-80 shrink-0" alt="" />
          @if (!collapsed) {
          <span class="text-white text-sm">{{ "sidebar.LOAN_HISTORY" | translate }}</span>
          }
        </li>
      </ul>
    </section>

    <!-- Security Section -->
    <section>
      <p
        class="text-white text-sm font-medium mb-2"
        [ngClass]="collapsed
          ? 'px-0 text-center text-[10px] underline-offset-2 truncate'
          : 'underline pl-3'">
        {{ collapsed ? ('sidebar.Security' | translate | slice:0:3) + '..' : ('sidebar.Security' | translate) }}
      </p>
      <ul class="space-y-1">
        <li
          (click)="close()"
          routerLink="/change-password"
          routerLinkActive="active-link"
          class="sidebar-item group flex items-center cursor-pointer hover:bg-white/10"
          [ngClass]="collapsed ? 'justify-center px-0 py-3' : 'gap-3 pl-3 py-3'"
          [title]="'sidebar.Change_Password' | translate">
          <img src="assets/SVG/sidebar/change_password.svg" class="w-5 h-5 opacity-80 shrink-0" alt="" />
          @if (!collapsed) {
          <span class="text-white text-sm">{{ "sidebar.Change_Password" | translate }}</span>
          }
        </li>
      </ul>
    </section>

    <!-- General Section -->
    <section>
      <p
        class="text-white text-sm font-medium mb-2"
        [ngClass]="collapsed
          ? 'px-0 text-center text-[10px] underline-offset-2 truncate'
          : 'underline pl-3'">
        {{ collapsed ? ('sidebar.General' | translate | slice:0:3) + '..' : ('sidebar.General' | translate) }}
      </p>
      <ul class="space-y-1">
        @if (screenWidth() > 600) {
        <li
          (click)="close()"
          routerLink="/deactivate-account"
          routerLinkActive="active-link"
          class="sidebar-item group flex items-center cursor-pointer hover:bg-white/10"
          [ngClass]="collapsed ? 'justify-center px-0 py-3' : 'gap-3 pl-3 py-3'"
          [title]="'sidebar.Deactive_Account' | translate">
          <img src="assets/SVG/sidebar/deactivate_account.svg" class="w-6 h-6 opacity-80 shrink-0" alt="" />
          @if (!collapsed) {
          <span class="text-white text-sm">{{ "sidebar.Deactive_Account" | translate }}</span>
          }
        </li>
        <li
          (click)="close()"
          routerLink="/user-profile"
          routerLinkActive="active-link"
          class="sidebar-item group flex items-center cursor-pointer hover:bg-white/10"
          [ngClass]="collapsed ? 'justify-center px-0 py-3' : 'gap-3 pl-3 py-3'"
          [title]="'sidebar.Profile' | translate">
          <img src="assets/SVG/sidebar/profile.svg" class="w-5 h-5 opacity-80 shrink-0" alt="" />
          @if (!collapsed) {
          <span class="text-white text-sm">{{ "sidebar.Profile" | translate }}</span>
          }
        </li>
        }
        <li
          (click)="openLanModal()"
          class="sidebar-item group flex items-center cursor-pointer hover:bg-white/10"
          [ngClass]="collapsed ? 'justify-center px-0 py-3' : 'gap-3 pl-3 py-3'"
          [title]="'sidebar.Language' | translate">
          <img src="assets/SVG/globe.svg" class="w-5 h-5 opacity-80 shrink-0" alt="" />
          @if (!collapsed) {
          <span class="text-white text-sm">{{ "sidebar.Language" | translate }}</span>
          }
        </li>
        <li
          (click)="close()"
          routerLink="/contact-support"
          routerLinkActive="active-link"
          class="sidebar-item group flex items-center cursor-pointer hover:bg-white/10"
          [ngClass]="collapsed ? 'justify-center px-0 py-3' : 'gap-3 pl-3 py-3'"
          [title]="'sidebar.CONTACT_SUPPORT' | translate">
          <img src="assets/SVG/sidebar/customer_support.svg" class="w-5 h-5 opacity-80 shrink-0" alt="" />
          @if (!collapsed) {
          <span class="text-white text-sm">{{ "sidebar.CONTACT_SUPPORT" | translate }}</span>
          }
        </li>
      </ul>
    </section>

    <!-- Logout -->
    <div class="w-full">
      <button
        type="button"
        class="sidebar-item mt-4 flex items-center text-white text-sm hover:bg-white/10 cursor-pointer w-full"
        [ngClass]="collapsed ? 'justify-center px-0 py-3' : 'gap-3 px-3 py-2'"
        [class.dead-link]="authService.logOutReqData.state().loading"
        [disabled]="authService.logOutReqData.state().loading"
        [title]="'sidebar.Log_Out' | translate"
        (click)="handleLogout()">
        <img src="assets/SVG/sidebar/logout.svg" class="w-5 h-5 opacity-80 shrink-0" alt="" />
        @if (!collapsed) {
          @if (authService.logOutReqData.state().loading) {
          <span class="flex items-center gap-2">
            <span class="loader"></span>
            {{ "common.PROCESSING" | translate }}
          </span>
          } @else {
          <span>{{ "sidebar.Log_Out" | translate }}</span>
          }
        }
      </button>
    </div>
  </div>
</aside>
